var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.22 48.4668H12V49.2868H51.22V48.4668Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3117 16.0664H26.0617C25.6199 16.0664 25.2617 16.4246 25.2617 16.8664V28.9564C25.2617 29.3982 25.6199 29.7564 26.0617 29.7564H38.3117C38.7535 29.7564 39.1117 29.3982 39.1117 28.9564V16.8664C39.1117 16.4246 38.7535 16.0664 38.3117 16.0664Z",
    stroke: "#485CC7",
    strokeWidth: 2.11,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1987 20.6865H14.8688C13.8194 20.6865 12.9688 21.5372 12.9688 22.5865V47.0165C12.9688 48.0659 13.8194 48.9165 14.8688 48.9165H49.1987C50.2481 48.9165 51.0988 48.0659 51.0988 47.0165V22.5865C51.0988 21.5372 50.2481 20.6865 49.1987 20.6865Z",
    fill: "#A7E2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0503 31.0469H13.0703V32.3769H51.0503V31.0469Z",
    fill: "#77D9F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0017 30.166C22.0017 29.6137 21.5562 29.166 21.0067 29.166C20.4572 29.166 20.0117 29.6137 20.0117 30.166V33.706C20.0117 34.2583 20.4572 34.706 21.0067 34.706C21.5562 34.706 22.0017 34.2583 22.0017 33.706V30.166Z",
    fill: "#485CC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5213 30.166C43.5213 29.6137 43.0758 29.166 42.5262 29.166C41.9767 29.166 41.5312 29.6137 41.5312 30.166V33.706C41.5312 34.2583 41.9767 34.706 42.5262 34.706C43.0758 34.706 43.5213 34.2583 43.5213 33.706V30.166Z",
    fill: "#485CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 48.8768,
    x2: 51.22,
    y2: 48.8768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashFlow);
export default __webpack_public_path__ + "static/media/cash-flow.aba4439a67d0f1aa469ee9951a2f4ad6.svg";
export { ForwardRef as ReactComponent };